import { BUILDING_TYPES_PRESENTER, IOfferBuilding } from '../../types/offers';

export const getBuildingType = (building?: IOfferBuilding) => {
  if (building && building.type) {
    const type = BUILDING_TYPES_PRESENTER[building.type];

    return type ? type.toLowerCase() : '';
  }

  return '';
};
